// ProtectedRoute.jsx
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Alert } from "@mui/material";
import { useTranslation } from "react-i18next";

function ProtectedRoute({ children, decoded, permission, fallback = "/" }) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const hasDirectPermission = decoded && decoded[permission];
  const hasPermissionInArray = decoded?.permissions?.includes(permission);
  const hasPermission = hasDirectPermission || hasPermissionInArray;

  useEffect(() => {
    if (decoded && !hasPermission) {
      setOpenSnackbar(true);
      setTimeout(() => {
        navigate(fallback);
      }, 1500);
    }
  }, [decoded, permission, fallback, navigate, hasPermission]);

  if (decoded && !hasPermission) {
    return (
      <Snackbar
        open={openSnackbar}
        autoHideDuration={4000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={() => setOpenSnackbar(false)}
          severity="error"
          sx={{ width: "100%" }}
        >
          {t("Access Denied to Page")}
        </Alert>
      </Snackbar>
    );
  }

  return children;
}

export default ProtectedRoute;
